const initialState = {
    fname: '',
    lname: '',
    gender: null,
};
const editPersonalInfo = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_EDIT_PERSONAL_INFO':
           return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default editPersonalInfo;
